/*
 * Copyright (C) 2021 Bosch.IO GmbH. All rights reserved.
 */
import React from 'react';
import { Dropdown, DropdownProps } from '../../atoms';

export interface LanguageSelectorProps
    extends React.ComponentPropsWithRef<'div'> {
    dropdown: DropdownProps;
    label: React.ReactElement;
}

export const LanguageSelector = React.forwardRef<
    HTMLDivElement,
    LanguageSelectorProps
>((props, ref) => {
    const { children, dropdown, label, ...rest } = props;
    const Label = children ? children : label;
    return (
        <div className="m-language-selector" ref={ref} {...rest}>
            {Label}
            <Dropdown {...dropdown} />
        </div>
    );
});

LanguageSelector.displayName = 'LanguageSelector';
